import { createSlice } from "@reduxjs/toolkit";

export const LangSettingsSlice = createSlice({
  name: "language",
  initialState: {
    country: "us",
    language: "en"
  },
  reducers: {
    changeCountry: (state, action) => {
      state.country = action.payload;
    },
    changeLanguage: (state, action) => {
      state.language = action.payload;
    }
  },
});

export const { changeCountry, changeLanguage } =
  LangSettingsSlice.actions;

export default LangSettingsSlice.reducer;
